module.exports = __webpack_public_path__ + "static/img/ptld_2@2x.09987d89.png";